/**
 * Category Navigation Helper
 *
 * Provides safe navigation utilities that handle category formatting
 * for transitions between V2 comparison routes and legacy routes.
 *
 * This is scoped to Industry Analysis routes only - does not affect global navigation.
 */

import { proNavigator } from "single-spa/react-app/ProNavigator";

import { isLegacyRoute, extractCategoriesFromRouteParams } from "./routeUtils";

/**
 * Navigate with automatic category formatting for legacy route compatibility
 * Use this instead of proNavigator.go() within Industry Analysis routes
 */
export const navigateWithCategorySupport = (stateName: string, params: any = {}, options: any = {}) => {
    if (isLegacyRoute(stateName)) {
        const currentRouteParams = proNavigator.getParams();
        const mergedParams = { ...currentRouteParams, ...params };
        const categoriesFromParams = extractCategoriesFromRouteParams(mergedParams);

        if (categoriesFromParams.length > 0) {
            // For legacy routes, use categories as-is since V2 redirects handle everything
            const paramsWithCategory = {
                ...mergedParams,
                category: categoriesFromParams,
            };

            return proNavigator.go(stateName, paramsWithCategory, options);
        }
    }

    return proNavigator.go(stateName, params, options);
};
